import { render, staticRenderFns } from "./recovery-check-features-tabs.vue?vue&type=template&id=031b03de"
import script from "./recovery-check-features-tabs.vue?vue&type=script&lang=js"
export * from "./recovery-check-features-tabs.vue?vue&type=script&lang=js"
import style0 from "./recovery-check-features-tabs.vue?vue&type=style&index=0&id=031b03de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports